<template>
	<form @submit.prevent="createTag()">
		<div class="row">
			<div class="col-sm-8">
				<div class="row">
					<div class="form-group col-sm-6 mb-4">
						<BaseInput
							name="tag"
							label="Tag"
							type="text"
							v-model="data.name"
							class="form-control form-control-lg dashInput"
							rules="required|min:3|max:50"
							@valError="inputError"
							@valSuccess="inputSuccess"
						/>
					</div>
					<div class="form-group col-sm-6 mb-4"></div>
					<div class="form-group col-sm-6 mt-2">
						<BaseButton
							class="btn btn-primary form-control form-control-lg"
							type="submit"
							label="Add Tag"
							:disabled="formState.disable"
							:loading="formState.isLoading"
						/>
					</div>
				</div>
			</div>
			<div class="col-sm-4 px-4">
				<h4 class="text-dark">Global Trip Holidays</h4>
				<p class="text-dark">
					Contacts are your customers you interact with in pursuit of a business
					opportunity.
				</p>
			</div>
		</div>
	</form>
</template>
<script>
	import { reactive } from "vue";
	import API from "@/config/api";
	import toast from "@/config/toast";
	import FormCheck from "@/helpers/formCheckHelper";
	import BaseInput from "./BaseInput";
	import BaseButton from "./BaseButton";

	export default {
		name: "TagCreate",
		components: {
			BaseInput,
			BaseButton,
		},
		setup: () => {
			const data = reactive({
				name: null,
			});
			const formState = reactive({
				isLoading: false,
				disable: true,
			});

			const nullable = [];
			const changeFormLoadingState = () =>
				(formState.isLoading = !formState.isLoading);

			const createTag = async () => {
				changeFormLoadingState();
				formState.disable = true;

				// if (validation.invalid.length) {
				// 	toast.error("Incomplete form", true);
				// 	changeFormLoadingState();
				// 	return;
				// }

				try {
					await API.privateRequest.post("tags", data);
					toast.success(
						{ message: "Tag created!", position: "topRight" },
						true,
					);
					changeFormLoadingState();
					data.name = null;
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error";
					}

					toast.error(message, true);
					changeFormLoadingState();
					formState.disable = false;
				}
			};

			// event handler for input validation event
			const inputError = (input) => {
				let check = FormCheck.valError(input, data, nullable);
				formState.disable = check;
			};

			const inputSuccess = (input) => {
				let check = FormCheck.valSuccess(input, data, nullable);
				formState.disable = check;
			};

			return {
				data,
				formState,
				createTag,
				inputError,
				inputSuccess,
			};
		},
	};
</script>
